import styled from "styled-components";

// Used for wrapping a page component
export const Screen = styled.div`
  background-color: var(--primary);
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

// Used for providing space between components
export const SpacerXSmall = styled.div`
  height: 8px;
  width: 8px;
`;

export const SpacerXSmall2 = styled.div`
  height: 6px;
  width: 6px;
`;

export const SpacerXXSmall = styled.div`
  height: 4px;
  width: 4px;
`;
export const SpacerXXXSmall = styled.div`
  height: 3px;
  width: 3px;
`;

export const SpacerXXXXSmall = styled.div`
  height: 1px;
  width: 1px;
`;


export const SecContainer = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "column")};
  justify-content: center;;
  align-items: center;
  font-family: 'Inter custom',sans-serif;
  background-color: ${({ test }) => (test ? "pink" : "none")};

  margin-top: 5%;
  @media (max-width: 565px) {
    font-size: 16px;


    line-height: 1;
  }

`;

export const TextP = styled.p`
text-align: center;
font-size: 1rem;
font-family: 'Inter custom',sans-serif;
letter-spacing: 1px;
line-height: 2;
width: 70%;
`;

// Used for providing space between components
export const SpacerSmall = styled.div`
  height: 16px;
  width: 16px;
`;



// Used for providing space between components
export const SpacerMedium = styled.div`
  height: 24px;
  width: 24px;
`;

// Used for providing space between components
export const SpacerLarge = styled.div`
  height: 32px;
  width: 32px;
`;

// Used for providing a wrapper around a component
export const Container = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "column")};
  justify-content: ${({ jc }) => (jc ? jc : "flex-start")};
  align-items: ${({ ai }) => (ai ? ai : "flex-start")};
  background-color: ${({ test }) => (test ? "pink" : "none")};
  width: 100%;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  @media (max-width: 565px) {
    font-size: 16px;
    width: 100%;
    line-height: 1;
    
  }
`;

export const Container1 = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "column")};
  justify-content: ${({ jc }) => (jc ? jc : "flex-start")};
  align-items: ${({ ai }) => (ai ? ai : "flex-start")};
  background-color: ${({ test }) => (test ? "pink" : "none")};
  width: 464px;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  @media (max-width: 580px) {
    font-size: 16px;
    width: 95%;
    line-height: 1;
  }


`;

export const Container3 = styled.div`
  display: flex;
  flex: ${({ flex }) => (flex ? flex : 0)};
  flex-direction: ${({ fd }) => (fd ? fd : "column")};
  justify-content: ${({ jc }) => (jc ? jc : "flex-start")};
  align-items: ${({ ai }) => (ai ? ai : "flex-start")};
  background-color: ${({ test }) => (test ? "pink" : "none")};
  width: 464px;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  @media (max-width: 580px) {
    font-size: 16px;
    width: 86%;
    line-height: 1;
  }


`;




export const TextTitle = styled.p`
  color: var(--primary-text);
  font-size: 22px;
  font-weight: 450;
  line-height: 1.6;
  @media (max-width: 565px) {
    font-size: 16px;
    font-weight: 250;
    line-height: 1;
  }
`;


export const StyledLink = styled.a`
  color: var(--primary-text);
  text-decoration: none;
  margin-right: 5rem;
  cursor: pointer;
  :hover {
    color: #FF8938;
  }
  @media (max-width: 835px) {
    margin-right: 0.75rem;
    margin-top: 1rem;
    display: none;
  }
`;

export const socialDiv = styled.div`
display: flex;
align-items: center;
@media (max-width: 565px) {
  margin-right: 0;
  margin-top: 20px;
  flex-direction: row;
  display: none;
}
`;

export const Icons = styled.img`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    :hover {
      transform: scale(1.5);
      transition: transform 0.5s;
    }
`;

export const innerIcons = styled.img`
    width: 45px;
    height: 45px;
    border-radius: 50%;
    margin-right: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const Headerlinks = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: 'Inter custom',sans-serif;
    @media (max-width: 300px) {
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 11px;
      font-family: 'Inter custom',sans-serif;
    }
`;
export const inputstyle = styled.input`
    display: flex; 
    background-color: #111119;
    align-items: center;
    @media (max-width: 300px) {
      margin-top: 10px;
      margin-bottom: 10px;
    }
`;

export const HeaderDiv = styled.div`
display: flex;
align-items: center;
margin-right: 0.8rem;
@media (max-width: 565px) {
  margin-right: 0;
  margin-top: 10px;
  margin-bottom: 20px;
  flex-direction: column-reverse;
}
`;

export const TextSubTitle = styled.p`
  color: var(--primary-text);
  font-size: 16px;
  color: white;
  line-height: 1.6;
  @media (max-width: 580px){
    font-size: 14px;
    font-weight: 250;
    line-height: 1.1;
  }
`;

export const TextDescription = styled.p`
  color: var(--primary-text);
  font-family: 'Inter custom',sans-serif;
  font-size: 15px;
  font-weight: normal;
  line-height: 1.6;
  @media (max-width: 565px) {
    font-size: 13px;
    font-weight: 250;
    line-height: 1.1;
  }
`;

export const TextDescriptionS = styled.p`
  color: var(--primary-text);
  font-family: 'Inter custom',sans-serif;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.6;
  @media (max-width: 565px) {
    font-size: 12px;
    font-weight: 250;
    line-height: 1.1;
  }
`;

export const StyledClickable = styled.div`
  :active {
    opacity: 0.6;
  }
`;
